import React from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface SidebarPanelProps {
  title: string;
  summary: string;
  icon: React.ComponentType<{ className?: string }>;
  open: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

export const SidebarPanel: React.FC<SidebarPanelProps> = ({
  title,
  summary,
  icon: Icon,
  open,
  onToggle,
  children,
}) => (
  <section className="card overflow-hidden">
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center gap-2 px-2.5 py-2 text-left hover:bg-primary-50/60 transition-colors"
    >
      <Icon className="w-3.5 h-3.5 shrink-0 text-primary-500" />
      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-primary-700">{title}</p>
        {!open && summary ? (
          <p className="text-[11px] text-slate-600 truncate mt-0.5">{summary}</p>
        ) : null}
      </div>
      {open ? (
        <ChevronDown className="w-3.5 h-3.5 shrink-0 text-slate-500" />
      ) : (
        <ChevronRight className="w-3.5 h-3.5 shrink-0 text-slate-500" />
      )}
    </button>
    {open ? <div className="px-2.5 pb-2.5 pt-0 space-y-2 border-t border-primary-100/30 bg-white">{children}</div> : null}
  </section>
);
